import * as React from "react";
import {Badge} from "react-bootstrap";
import renderUtils from "../../helpers/renderUtils";
import { useTranslation } from 'react-i18next';

export const useTableColumns = () => {
    const { t } = useTranslation();
    
    return [
        {
            label: "ID",
            field: "id",
            sort: "desc",
            width: 200,
        },
        {
            label: t("common.part_name"),
            field: "name",
            sort: "desc",
            width: 200,
            type: "tooltipImage",
            resolveImage: function (row) {
                return row.files[0];
            },
        },
        {
            label: t("object_types.machine"),
            field: "machineType",
            sort: "desc",
            width: 200,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return <Badge
                    className={"outline-secondary font-max"}> {renderUtils.renderMachineType({machineType: row.machineType}, t)}</Badge>
            }
        },
        {
            label: t("forms.category_name"),
            field: "category",
            sort: "desc",
            width: 200,
            type: "badge"
        },
        {
            field: "type",
            label: t("forms.type"),
            sort: "desc",
            width: 200,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return row.type && <Badge
                    className={"outline-secondary font-max"}> {renderUtils.renderEnumName(row.type, "enums/partType", t)}</Badge>
            }
        },
        {
            field: "partNumber",
            label: t("common.part_number"),
            sort: "desc",
            width: 200,
        },
        {
            field: "label",
            label: t("common.comment"),
            sort: "desc",
            width: 200,
        },
        {
            field: "formatId",
            label: t("object_types.format"),
            sort: "desc",
            type: "badge",
            badgeType: "badge-primary",
            width: 200,
        },
        {
            label: t("forms.withdrawal_date"),
            field: "withdrawalDate",
            type: "badge",
            sort: "desc",
            width: 53,
        },
        {
            label: t("common.user_withdrawn"),
            field: "withdrawalUser",
            type: "badge",
            sort: "desc",
            width: 53,
        }
    ];
};

// Legacy export for backward compatibility
const columns = (t) => [
        {
            label: "ID",
            field: "id",
            sort: "desc",
            width: 200,
        },
        {
            label: t ? t("common.part_name") : "Nazwa części",
            field: "name",
            sort: "desc",
            width: 200,
            type: "tooltipImage",
            resolveImage: function (row) {
                return row.files[0];
            },
        },
        {
            label: t ? t("common.machine") : "Maszyna",
            field: "machineType",
            sort: "desc",
            width: 200,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return <Badge
                    className={"outline-secondary font-max"}> {renderUtils.renderMachineType({machineType: row.machineType})}</Badge>
            }
        },
        {
            label: t ? t("common.category") : "Kategoria",
            field: "category",
            sort: "desc",
            width: 200,
            type: "badge"
        },
        {
            field: "type",
            label: t ? t("common.kind") : "Rodzaj",
            sort: "desc",
            width: 200,
            type: "custom",
            custom: function (column, row, history, internalReload, setInternalReload, setLoader, disableRule, externalState) {
                return row.type && <Badge
                    className={"outline-secondary font-max"}> {renderUtils.renderEnumName(row.type, "enums/partType")}</Badge>
            }
        },
        {
            field: "partNumber",
            label: t ? t("common.number") : "Numer",
            sort: "desc",
            width: 200,
        },
        {
            field: "label",
            label: t ? t("common.comment") : "Komentarz",
            sort: "desc",

            width: 200,
        },
        {
            field: "formatId",
            label: t ? t("common.format") : "Format",
            sort: "desc",
            type: "badge",
            badgeType: "badge-primary",
            width: 200,
        },
        {
            label: t ? t("common.withdrawal_date") : "Data wycofania",
            field: "withdrawalDate",
            type: "badge",
            sort: "desc",
            width: 53,
        },
        {
            label: t ? t("common.user_withdrawn") : "Użytkownik wycofał",
            field: "withdrawalUser",
            type: "badge",
            sort: "desc",
            width: 53,
        },

    ];

export default columns;